<template>
    <BaseTooltip v-model:open="open">
        <template #trigger><slot name="trigger"></slot></template>
        <template #content>
            <div ref="overflowContainer" :class="classes.boundedContent">
                <div :class="[classes.preview, { [classes.fade]: isOverflowing }]">
                    <div ref="overflowContent"><slot name="content"></slot></div>
                </div>
                <p v-if="isOverflowing" class="body-small-bold shrink-0 pt-3 text-center">{{ t("developmentJourneys.goalProgress.clickForFullDetails") }}</p>
            </div>
        </template>
    </BaseTooltip>
</template>

<script setup lang="ts">
import { useResizeObserver } from "@vueuse/core";
import BaseTooltip from "~vue/components/BaseTooltip.vue";
import { ref, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const open = defineModel<boolean>("open");
const overflowContainer = useTemplateRef<HTMLDivElement>("overflowContainer");
const overflowContent = useTemplateRef<HTMLDivElement>("overflowContent");
const isOverflowing = ref(false);

useResizeObserver([overflowContainer, overflowContent], () => {
    const container = overflowContainer.value;
    const content = overflowContent.value;
    // Compare with the whole available area so the hint cannot keep itself visible after a resize.
    isOverflowing.value = !!container && !!content && content.scrollHeight > container.clientHeight + 1;
});
</script>

<style module="classes">
@reference "../../../../../css/tailwind.css";
@layer components {
    .boundedContent {
        display: flex;
        flex-direction: column;
        max-height: max(0px, calc(var(--reka-tooltip-content-available-height) - 2rem));
    }

    .preview {
        min-height: 0;
        overflow: hidden;
    }

    .fade {
        mask-image: linear-gradient(to bottom, black calc(100% - 2rem), transparent);
    }
}
</style>
